module.exports = __webpack_public_path__ + "static/media/food1.d60e1e36.png";